export const joinRoom = (dispatch, apiClient, roomName) => {
  return apiClient
    .call({ endpoint: 'user/joinRoom', data: { roomName } })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'USER_SET_ROOM', room: res.data.roomName });
    });
};

export const send = (dispatch, apiClient, roomId, type, payload) => {
  return apiClient
    .call({
      endpoint: 'room/send',
      data: { roomId, type, payload }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: 'Problem sending message to room',
        snackType: 'warning'
      });
      throw e;
    });
};



// WEBPACK FOOTER //
// ./app/actions/rooms.js